import classnames from 'classnames';

import { Div } from './HTMLElement';
import { RecommendedCartProductsProps } from './RecommendedCartProducts';
import { RecommendedCartProductTile } from './RecommendedCartProductTile';
import { useUpsellProducts } from './useUpsellProduct';

export const RecommendedCartProductsA = ({ classNames, limit }: RecommendedCartProductsProps) => {
  const { loading, products } = useUpsellProducts();
  return (
    <Div className={classnames('recommended-cart-products', classNames)}>
      <Div className="header" paddingY={2}>
        <h6 className="title">Compra con</h6>
      </Div>
      {loading ? (
        'Stiamo analizzando dei prodotti consigliati per te'
      ) : (
        <>
          {products?.slice(0, limit).map((product) => (
            <Div className="content" key={product.id} uiClassName={{ bs5: 'bg-white border-bottom' }}>
              <RecommendedCartProductTile product={product} />
            </Div>
          ))}
        </>
      )}
    </Div>
  );
};
